<template>
  <div id="acDetail">
    <!-- 设备基本信息 -->
    <el-row>
      <!-- <p>acTabPaneInfo--tem---{{ acTabPaneInfo }}</p> -->
      <!-- 流程图 -->
      <div class="paneDivWarp" style="padding-bottom: 36px;">
        <p class="flowP">
          {{ acSn }}
          <span>{{ acInfoTem.timeAgo }}</span>
        </p>
        <div class="flowDivWarp">
          <img v-if="acInfoTem.ch1A!='--'" src="@/assets/images/kisae/flowChart/acFlow1.gif" alt="" style="width: 100%;">
          <img v-else-if="acInfoTem.ch2A!='--'" src="@/assets/images/kisae/flowChart/acFlow2.gif" alt="" style="width: 100%;">
          <img v-else-if="acInfoTem.ch3A!='--'" src="@/assets/images/kisae/flowChart/acFlow3.gif" alt="" style="width: 100%;">
          <img v-else src="@/assets/images/kisae/flowChart/acOfflineFlow.jpg" alt="" style="width: 100%;">
          <div class="altData flowDataDiv">
            <p>{{ acInfoTem.batV }} V</p>
            <!-- <p>{{ acInfoTem.batA }} A</p> -->
          </div>
          <div class="cellData1 flowDataDiv">
            <p>{{ acInfoTem.ch1V }} V</p>
            <p>{{ acInfoTem.ch1A }} A</p>
          </div>
          <div class="cellData2 flowDataDiv">
            <p>{{ acInfoTem.ch2V }} V</p>
            <p>{{ acInfoTem.ch2A }} A</p>
          </div>
          <div class="cellData3 flowDataDiv">
            <p>{{ acInfoTem.ch3V }} V</p>
            <p>{{ acInfoTem.ch3A }} A</p>
          </div>
        </div>
      </div>
      <!-- 状态 -->
      <div class="paneDivWarp paneDivStatusWarp">
        <div class="divWarp25">
          <div class="paneDivStatusImg">
            <img v-if="!acInfoTem.online" src="@/assets/images/kisae/chargeStage_offline.png" alt="">
            <img v-else-if="acInfoTem.online&&acInfoTem.status===0" src="@/assets/images/kisae/3-1.png" alt="">
            <img v-else-if="acInfoTem.online&&acInfoTem.status==1" src="@/assets/images/kisae/3-2.png" alt="">
            <img v-else-if="acInfoTem.online&&acInfoTem.status==2" src="@/assets/images/kisae/3-3.png" alt="">
            <img v-else src="@/assets/images/kisae/chargeStage_online.png" alt="">
          </div>
          <div class="paneDivStatusP">
            <p>STATUS</p>
            <p v-if="acInfoTem.online&&acInfoTem.status===0" class="statusP">Bulk</p>
            <p v-else-if="acInfoTem.online&&acInfoTem.status==1" class="statusP">ABS</p>
            <p v-else-if="acInfoTem.online&&acInfoTem.status==2" class="statusP">Float</p>
            <!-- <p v-else class="statusP">--</p> -->
            <p v-else class="statusP">ABS</p><!-- 假数据 -->
          </div>
        </div>
      </div>
      <!-- 警告 -->
      <div class="paneDivWarp warningWarp">
        <el-table :data="warningList" style="width: 100%" :show-header="false" empty-text="The device has no warning for the time being.">
          <el-table-column width="100">
            <template slot-scope="scope">
              <img :src="scope.row.imgUrl" alt="" style="width: 80px;">
              <!-- <img src="@/assets/images/warningSimpleImg/E02.png" alt=""> -->
            </template>
          </el-table-column>
          <el-table-column prop="question">
            <template slot-scope="scope">
              <span>{{ scope.row.question }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="answer" />
        </el-table>
      </div>
    </el-row>
  </div>
</template>

<script>
import i18n from '@/i18n'
import { updateTimeOnlyEn } from '@/utils/updateTime.js'

export default {
  name: '',
  components: {
  },
  props: {
    acTabPaneInfo: {
      type: Object,
      default: () => { }
    },
    acSn: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      acInfoTem: {
        batV: '--',
        batA: '--',
        ch1V: '--',
        ch1A: '--',
        ch2V: '--',
        ch2A: '--',
        ch3V: '--',
        ch3A: '--',
        timeAgoRes: null,
        timeAgo: null
      },
      warningList: [],
      warningAcInfo: [// ac警告文字
        { key: 'A01', question: 'Temperature Sensor (BTS) is defective.', answer: 'Check and or replace the sensor.' },
        { key: 'E01', question: 'Unit shutdown due to low AC Input(< 85 +/- 5Vac)', answer: 'Check AC input source. The unit will automatically recover when the AC Input voltage return to > 108 +/-5Vac' },
        { key: 'E02', question: 'Unit shutdown due to high AC Input(>270 +/- 5Vac)', answer: 'Check AC input source. The unit will automatically recover when the AC Input voltage return to < 260 +/-5Vac' },
        { key: 'E03', question: 'Battery is connected backwards', answer: 'Check all battery connections' },
        { key: 'E04', question: 'Charger Internal temperature is too high and it has to shut down. The unit will automatically recover when the unit cools down.', answer: 'The ventilation of the unit is blocked or the environmental temperature is high. Reduce charging current or improve the ventilation near the unit.' },
        { key: 'E06', question: 'High battery temperature >70 °C (158°C) is sensed by the BTS. The unit will shut down. The unit will automatically recover when the battery temperature has reduced to 60°C (140°F).', answer: 'Check the battery, charger setting, and its environment.' },
        { key: 'E07', question: 'Low battery temperature < -25°C (-13°F) is sensed by the BTS. The unit will shut down. The unit will automatically recover when battery temperature reaches -20°C (-4°F).', answer: 'It is not recommended to charge the battery at extremely low temperatures.' },
        { key: 'E08', question: 'DC Output fuses are brown.', answer: 'Check battery connection and replace the fuse with the same type and rating.' },
        { key: 'E09', question: 'Unit shutdown due to high battery voltage (> 17 Vdc on 12V model and >34 Vdc on 24V model). The unit will automatically recover when battery Voltage reduced to <16Vdc on 12V model or <32 Vdc on 24V model.', answer: 'Check battery and charger setting. Check also if there is any other DC supply connected to the battery banks.' }
      ],
      timer: null
    }
  },
  computed: {
    language() {
      return this.$store.state.language
    }
  },
  watch: {
    acTabPaneInfo: {
      handler(newValue, oldValue) {
        // this.acInfoTem = newValue // 把新值赋值给我们的属性数据
        // console.log('watch*********', this.acInfoTem)
        this.MQTT()
      },
      deep: true,
      immediate: true
    },
    language(newValue, oldValue) {
      if (this.acInfoTem.timeAgoRes) this.acInfoTem.timeAgo = updateTimeOnlyEn(this.acInfoTem.timeAgoRes)
    }
  },
  created() {
    // 每次进入界面时，先清除之前的所有定时器，然后启动新的定时器
    clearInterval(this.timer)
    this.timer = null
    this.setTimer()
  },
  destroyed: function() {
    // 每次离开当前界面时，清除定时器
    clearInterval(this.timer)
    this.timer = null
    this.setTimer()
  },
  mounted() {

  },
  methods: {
    MQTT() {
      if (this.acTabPaneInfo.dataFrom == 'api') {
        console.log('mqtt**acTem********', this.acTabPaneInfo)
        this.acInfoTem.timeAgoRes = this.acTabPaneInfo.timeAgoRes
        this.acInfoTem.timeAgo = updateTimeOnlyEn(this.acInfoTem.timeAgoRes)
        this.acInfoTem.online = false
      } else if (this.acTabPaneInfo.dataFrom == 'mqtt') {
        if (!this.acTabPaneInfo) return
        this.acInfoTem.timeAgo = 'A Moment Ago'
        this.acInfoTem.timeAgoRes = new Date().getTime()
        // this.acTabPaneInfo.connection = 0
        if (this.acTabPaneInfo.connection === 1) { // 设备状态 1：连接 0：断开
          this.acInfoTem.online = true
        } else {
          this.acInfoTem.online = false
        }
        if (this.acTabPaneInfo.machineModel) this.acInfoTem.acBatteryType = this.acTabPaneInfo.machineModel.toString(16)
        var batConnectedArr11 = this.decimalToBinary(this.acTabPaneInfo.batConnected || 0)
        // batConnectedArr11 = [0, 0, 1, 0]
        // console.log('batConnectedArr11', batConnectedArr11)
        this.acInfoTem.ch1A = this.acInfoTem.ch2A = this.acInfoTem.ch3A = '--'
        this.acInfoTem.ch1V = this.acInfoTem.ch2V = this.acInfoTem.ch3V = '--'
        if (batConnectedArr11[0] == 1) {
          this.acInfoTem.status = this.acTabPaneInfo.ch1ChangeStage
          // this.acInfoTem.ch1V = this.acTabPaneInfo.CH1_V < 100 ? '--' : this.acTabPaneInfo.CH1_V
          this.acInfoTem.ch1V = (this.acTabPaneInfo.CH1_V / 100).toFixed(2)
          this.acInfoTem.ch1A = (this.acTabPaneInfo.charge_I / 100).toFixed(2)
        } else if (batConnectedArr11[1] == 1) {
          this.acInfoTem.status = this.acTabPaneInfo.ch2ChangeStage
          this.acInfoTem.ch2V = (this.acTabPaneInfo.CH2_V / 100).toFixed(2)
          this.acInfoTem.ch2A = (this.acTabPaneInfo.charge_I / 100).toFixed(2)
        } else if (batConnectedArr11[2] == 1) {
          this.acInfoTem.status = this.acTabPaneInfo.ch3ChangeStage
          this.acInfoTem.ch3V = (this.acTabPaneInfo.CH3_V / 100).toFixed(2)
          this.acInfoTem.ch3A = (this.acTabPaneInfo.charge_I / 100).toFixed(2)
        }
        this.acInfoTem.batV = (this.acTabPaneInfo.AC_V / 100).toFixed(2)
        this.acInfoTem.batA = (this.acTabPaneInfo.charge_I / 100).toFixed(2)
        // this.acTabPaneInfo.errorCode = 3// 假数据
        // 警告
        this.warningList = []
        if (this.acTabPaneInfo.errorCode) {
          this.warningAcInfo.forEach(v => {
            if (v.key == ('E0' + this.acTabPaneInfo.errorCode)) {
              this.warningList.push({
                imgUrl: require('@/assets/images/warningSimpleImg/E0' + this.acTabPaneInfo.errorCode + '.png'),
                question: v.question,
                answer: v.answer
              })
            }
          })
        }
        if (!this.acInfoTem.online) {
          for (var k in this.acInfoTem) {
            // console.log(k)
            if (k != 'online') {
              this.acInfoTem[k] = '--'
              this.warningList = []
            }
          }
        }
        console.log('mqtt**acInfoTem********', this.acInfoTem)
      }

      // this.acInfoTem.sn = this.acTabPaneInfo.sn
      // this.acInfoTem.online = this.acInfoTem.online
      // this.acInfoTem.MqttOnline = this.acInfoTem.online
    },
    setTimer() { // 定时器
      if (this.timer == null) {
        this.timer = setInterval(() => {
          if (this.acInfoTem.timeAgoRes) this.acInfoTem.timeAgo = updateTimeOnlyEn(this.acInfoTem.timeAgoRes)
        }, 60000)
      }
    },
    decimalToBinary(num) { // 十进制转二进制
      var myNum = num
      var b = []
      while (1) {
        var remainder = num % 2
        b.unshift(remainder)
        num = parseInt(num / 2)
        if (num == 0) break
      }
      var len
      if (myNum < 10) {
        len = 4 - b.length
        for (var i = 0; i < len; i++) {
          b.unshift(0)
        }
      } else if (myNum >= 10 && myNum < 100) {
        len = 8 - b.length
        for (var j = 0; j < len; j++) {
          b.unshift(0)
        }
      }
      return b.reverse()
      // return b
    }
  }
}
</script>
<style lang="scss">
#acDetail{
  .altData{
    left: calc(7.5% - 40px);
    top: 56%;
  }
  .cellData1{
    left: calc(76% - 40px);
    top: 26%;
  }
  .cellData2{
    left: calc(94.3% - 40px);
    top: 57.6%;
  }
  .cellData3{
    left: calc(76% - 40px);
    top: 97%;
  }
}
</style>
